// item 234/236 — company-wide DEFAULT markups (multipliers over dealer cost). The
// GROUP price (cost × groupMarkup) is what we sell at — the binding price for all
// totals. SRP/MSRP are customer-facing SUGGESTIONS shown alongside (display-only):
// srpMarkup drives the SRP shown on proposals, msrpMarkup the MSRP on sales orders.
// An item with its own group markup overrides groupMarkup; all fall back to these.
export interface PricingSettings {
  groupMarkup: number;
  srpMarkup: number;
  msrpMarkup: number;
}

export const DEFAULT_PRICING_SETTINGS: PricingSettings = {
  groupMarkup: 1.3,
  srpMarkup: 2.0,
  msrpMarkup: 2.0,
};
